export default __webpack_public_path__ + "static/onstage-5dd7e1822cff705bf535ad27ab23e52c.jpg";